import img1 from "../img/profile-1.png"
import img2 from "../img/profile-5.png"
import post1 from "../img/post1.jpg"
import post2 from "../img/post2.jpg"
import post3 from "../img/post3.jpg"

const Data = [
    {
        id:0,
        title:'The Partner 1',
        status:"cancelled",
        client:"Nick",
        detail:'',
        address:'',
    },
    {
        id:1,
        title:'Client2',
        status:"delivered",
        client:"john",
        detail:'',
        address:'',
    },
    {
        id:2,
        title:'The Partner 1',
        status:"pending",
        client:"Nick knight",
        detail:'',
        address:'',
    },
    {
        id:3,
        title:'Client2',
        status:"delivered",
        client:"John doe",
        detail:'',
        address:'',
    },
    {
        id:4,
        title:'The Partner 1',
        status:"shipped",
        client:"",
        detail:'',
        address:'address',
    },
    {
        id:5,
        title:'Client2',
        status:"pending",
        client:"MAyank",
        detail:'',
        address:'address',
    }
]
export default Data